import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-product-id";
import * as z from "zod";

export const getProductFamilyVariants = {
  name: "getProductFamilyVariants" as const,
  input: z.object({ productFamilyId: productFamilyIdFormat.schema }),
  output: z.object({
    filters: z.array(
      z.object({ name: z.string(), values: z.array(z.string()) }),
    ),
    variants: z.array(
      z.object({
        productId: productIdFormat.schema,
        title: z.string(),
        sku: z.string().nullable(),
        imageUrl: z.string().nullable(),
        attributes: z.array(z.object({ name: z.string(), value: z.string() })),
      }),
    ),
  }),
};
